import vs from './default-raw-vs.glsl'
import fs from './scratch-three.glsl'

const ScratchShader = {
  uniforms: {
    tDiffuse: { value: null },
    uStrength: { value: 0.3 },
    uRand: { value: 0 },
  },
  vertexShader: vs,
  fragmentShader: fs,
}

export { ScratchShader }
